const SectionUserContentBase = Class(
	/**
	 * @lends {SectionUserContentBase#}
	 */
	{
		bodyClass: 'small-nav grey full-container',
		showTabs: true,
		name: 'user-content',

		route: function() {
			if (!D.ID) {
				Section.navigate(
					D.url('/sign-in?redirect=' + encodeURIComponent(window.location.pathname + '?' + window.location.search))
				);
				return false;
			}
			if (this.url.get.is('event_id')) {
				SectionUserContent.EVENT_ID = Number(this.url.get.v('event_id')) || 0;
			}
		},

		draw: function() {
			this.rpc = new RPC('/api/web_rpc.php?EVENT_ID=' +  SectionUserContent.EVENT_ID);
			this._drawBase();
		},

		_drawBase: function() {
			this._containerNode = mkE({
				tag: 'div',
				id: 'user-content',
				els: [
					this._mainNode = mkE({
						tag: 'div',
						className: 'main',
						els: [
							this._mainContentNode = mkE({
								tag: 'div',
								className: 'main-content'
							})
						]
					})
				]
			});

			if (this.showTabs) {
				let menuItems = [
					{
						name: 'activeEvents',
						url: D.url('/profile/events'),
						caption: D.Lang.get('profile.menu.activeEvents')
					},
					{
						name: 'pastEvents',
						url: D.url('/profile/past'),
						caption: D.Lang.get('profile.menu.pastEvents')
					},
					{
						name: 'user-content',
						url: D.url('/user-content/my'),
						caption: D.Lang.get('profile.menu.userContent')
					},
					{
						name: 'edit',
						url: D.url('/profile/edit'),
						caption: D.Lang.get('profile.menu.edit')
					}
				];
				this._tabs = new T.MainTabs({
					items: menuItems,
					active: this.name
				});
				this._tabs.prepend(this._mainNode);
			}

			this._containerNode.append(this.layout.ct());
			this._draw();
		},

		/**
		 * @abstract
		 * @protected
		 */
		_draw: function() {
		}
	},
	Section
);

const SectionUserContent = Class(
	/**
	 * @lends {SectionUserContent#}
	 */
	{
		bodyClass: 'small-nav grey full-container',
		menuItem: 'user-content',
		showTabs: false,

		route: function() {
			let part = this.url.shift();
			switch (part) {
				case 'edit':
					return new SectionUserContent.Edit();
				case 'my':
					return new SectionUserContent.My();
				default:
				case 'add':
					return new SectionUserContent.Add();
			}
		}

	},
	SectionUserContentBase
);

SectionUserContent.EVENT_ID = 0;